import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "Lernen",
  "lead": "In mindestens 15 Ländern Subsahara Afrikas erreicht mehr als die Hälfte der Schüler am Ende der Grundschulzeit nicht das erforderliche Mindestniveau an Lesekompetenz."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Figure, HighlightByIndex, IndicatorReference, RelatedMaterial, ScrollyArea, ScrollySection, ScrollySticky} = _components;
  if (!Figure) _missingMdxReference("Figure", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_LEARNING"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "Es reicht nicht aus, Kinder in die Schule zu schicken. Ohne die vielen anderen wichtigen Ziele, die Schulen verfolgen müssen, zu mindern, sollten Schüler in der Lage sein, zu lesen und grundlegende mathematische Aufgaben zu bewältigen. Sie bilden die Grundlage für weiteres Lernen, die persönliche Entfaltung und das Wohlbefinden sowie für soziale, politische und wirtschaftliche Erfolge."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "kinder-und-jugendliche",
      children: "Kinder und Jugendliche"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.1",
      label: "4.1.1a",
      children: [_jsx(_components.p, {
        children: "In vielen der ärmsten Länder der Welt fehlt es zahlreichen Kindern an grundlegenden Lese- und Mathematikkenntnissen.\nIn den nördlichen Bundesstaaten Nigerias (z. B. Kaduna und Sokoto) sowie in Provinzen der Demokratischen Republik Kongo (z. B. Äquateur und Katanga) wurde festgestellt, dass mehr als 80 % der Drittklässler in der Grundschule nicht einmal ein einziges Wort eines zusammenhängenden Textes lesen können."
      }), _jsx(Figure, {
        id: "EGRA"
      })]
    }), "\n", _jsx(_components.p, {
      children: "Diese Daten beziehen sich nicht auf die Kinder, die überhaupt nicht zur Schule gehen. Erhebungen, die zu Hause durchgeführt werden, ermöglichen es, die Fähigkeiten sowohl von Kindern, die zur Schule gehen, als auch von Kindern, die nicht zur Schule gehen, zu erfassen."
    }), "\n", _jsx(_components.p, {
      children: "Die folgenden Diagramme zeigen beispielsweise verschiedene Regionen in Pakistan und ländliche Gebiete Indiens, basierend auf Bewertungen durch die Bürger."
    }), "\n", _jsxs(_components.p, {
      children: ["Die", _jsx(HighlightByIndex, {
        index: "1",
        children: "roten Linien"
      }), " zeigen den Prozentsatz der Kinder ", _jsx(_components.strong, {
        children: "in der Schule"
      }), ", die über grundlegende Lesefähigkeiten verfügen, während die", _jsx(HighlightByIndex, {
        index: "0",
        children: "blauen Linien"
      }), " den Prozentsatz der Kinder anzeigen, die über grundlegende Lesefähigkeiten verfügen, ", _jsx(_components.strong, {
        children: "egal ob sie altergerecht eingeschult worden sind oder nicht"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "Die Lücken zwischen den beiden Linien verdeutlichen, dass politische Entscheidungsträger in Ländern mit hohen Schulabbrecherquoten nur ein unvollständiges Bild erhalten, wenn sie lediglich das Lernen derjenigen beobachten, die die Schule besuchen. Es ist wichtig zu betonen, dass das überwachte Qualifikationsniveau sehr gering ist. Selbst in den leistungsstärksten Regionen sind zumindest einige Jugendliche in der Sekundarstufe nicht in der Lage, einen Text auf dem Niveau der 2. Klasse zu lesen."
    }), "\n", _jsx(Figure, {
      id: "LEARN_AGE_GRADE"
    }), "\n", _jsx(IndicatorReference, {
      id: "4.1.1",
      label: "4.1.1b",
      children: _jsx(_components.p, {
        children: "Schätzungen zufolge können fast 40 % der Kinder im Grundschulalter grundlegende Lesefähigkeiten nicht vorweisen. Dies betrifft 70 % der Kinder in den Ländern Subsahara Afrikas, während nur 3 % der Kinder in Europa und Nordamerika betroffen sind."
      })
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.0",
      label: "4.1.0",
      children: [_jsx(_components.p, {
        children: "In vielen Ländern ist es keine Garantie, dass Kinder in der Lage sind zu lesen, selbst wenn sie die Grundschule abgeschlossen haben. Weltweit hatten vier von zehn Grundschulabsolventen keine grundlegenden Lesefähigkeiten. In Ländern mit niedrigem Einkommen sind es sogar 8 von 10, wie die folgende Grafik veranschaulicht."
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "LEARN_REACHFINAL"
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["Die ", _jsx(HighlightByIndex, {
              index: "-1",
              children: "grauen Abschnitte"
            }), " zeigen den Prozentsatz der Kinder, die die Grundschule abschließen, aber nicht über grundlegende Lesefähigkeiten verfügen. Die ", _jsx(HighlightByIndex, {
              index: "1",
              children: "roten Abschnitte"
            }), " zeigen die Schüler, die die Grundschule abgeschlossen und ein Mindestniveau erreicht haben, und die ", _jsx(HighlightByIndex, {
              index: "0",
              children: "blauen Abschnitte"
            }), " zeigen die Kinder, die die Grundschule nicht abschließen."]
          })
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "In Ländern wie dem Tschad und Nigeria waren etwa 90 % der jungen Menschen, die die Schule nach 5 oder 6 Jahren verließen, nicht alphabetisiert. Einige Länder hingegen verzeichnen wesentlich bessere Quoten. In Ländern wie Burundi, Costa Rica und Honduras konnten nahezu alle Schüler, die die Schule nach der 5. oder 6. Klasse verließen, grundlegende Lese- und Schreibfähigkeiten vorweisen."
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "LITBYYRS"
        })
      }), _jsx(ScrollySection, {
        id: "KEN",
        children: _jsxs(_components.p, {
          children: ["In ", _jsx(_components.strong, {
            children: "Kenia"
          }), " zum Beispiel kann nur jedes vierte Kind lesen und schreiben ", _jsx(HighlightByIndex, {
            index: "1",
            children: " mit bis zu 4 Jahren Schulbildung"
          }), ", aber diese Zahl steigt auf drei von vier bei denjenigen, die eine ", _jsx(HighlightByIndex, {
            index: "0",
            children: "5-6 Jahre Schulbildung"
          }), " - das Äquivalent einer Grundschulbildung."]
        })
      }), _jsx(ScrollySection, {
        id: "BFA",
        children: _jsxs(_components.p, {
          children: ["In ", _jsx(_components.strong, {
            children: "Burkina Faso"
          }), ", kann kaum ein Kind", _jsx(HighlightByIndex, {
            index: "1",
            children: "nach vier Jahren Schulbildung"
          }), " lesen. Jedoch entwickeln mehr als die Hälfte über grundlegende Lesefähigkeiten, ", _jsx(HighlightByIndex, {
            index: "0",
            children: "wenn sie die Grundschule abgeschlossen haben"
          }), "."]
        })
      })]
    }), "\n", _jsx(_components.p, {
      children: "Um das Lernen in verschiedenen Ländern vergleichen zu können, müssen Bewertungen oder Tests an internationalen Standards ausgerichtet werden, wobei eine einheitliche Definition zugrunde gelegt wird. Kürzlich wurden solche Standards für länderübergreifende Prüfungen eingeführt, bei denen Schüler aus verschiedenen Ländern denselben Test ablegen. Für nationale Bewertungen gibt es jedoch noch nicht so viele solcher Zuordnungen."
    }), "\n", _jsx(_components.p, {
      children: "Eine dieser Bewertungen, die Trends in International Mathematics and Science Study (TIMSS), wird alle vier Jahre durchgeführt und ermöglicht es, die Fortschritte von Schülern der Klassen 4 und 8 im Laufe der Zeit zu verfolgen. Sie zeigt auf, in welchen Bereichen der Fortschritt besonders langsam war. In Ägypten stieg beispielsweise der Anteil der Achtklässler, die die Mindestanforderungen in Mathematik erfüllten, von 24 % im Jahr 2003 auf nur 27 % im Jahr 2019."
    }), "\n", _jsxs(_components.p, {
      children: ["Einige Länder, wie z B ", _jsx(HighlightByIndex, {
        index: "0",
        children: "Malaysia"
      }), "haben sogar festgestellt, dass der Anteil der Schüler, die das Mindestlernniveau erreichen, im Laufe der Zeit abnimmt."]
    }), "\n", _jsxs(_components.p, {
      children: ["In anderen Ländern, wie z. B ", _jsx(HighlightByIndex, {
        index: "1",
        children: "Bahrain"
      }), ", hat sich der Anteil der Schüler mit Mindestkenntnissen hat zwischen 2003 und 2019 mehr als verdreifacht."]
    }), "\n", _jsx(Figure, {
      id: "PIRLSGAIN"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.1",
      label: "4.1.1b",
      children: [_jsx(_components.p, {
        children: "Entgegen der allgemeinen Erwartung sind die geschlechtsspezifischen Lernunterschiede eher gering – in der Grundschulbildung betragen sie in fast allen Ländern beispielsweise nicht mehr als zehn Prozentpunkte."
      }), _jsx(_components.p, {
        children: "Jedoch sind die Lernunterschiede zwischen den Ländern enorm. In den Ländern Subsahara Afrikas, die bei der Lesekompetenz in der Primarstufe häufig zu den Schlusslichtern gehören, variiert der Anteil der Schüler, die die Mindestanforderungen erfüllen, erheblich – von nur 4 % in Burundi bis zu 76 % in Gabun (beide Ergebnisse von PASEC 2019)."
      }), _jsx(_components.p, {
        children: "In Mathematik in der Primarstufe variieren die Quoten in den südostasiatischen Ländern erheblich – von nur 8 % in der Demokratischen Volksrepublik Laos bis zu 91 % in Vietnam (beide Ergebnisse aus SEA-PLM 2019)."
      }), _jsx(Figure, {
        id: "ASSESS"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "erwachsene",
      children: "Erwachsene"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.6.2",
      children: [_jsx(_components.p, {
        children: "Zwischen 2000 und 2023 wird der Prozentsatz der Erwachsenen, die lesen und schreiben können, weltweit von 81 % auf 87 % steigen, während der Prozentsatz der Jugendlichen, die lesen und schreiben können, von 87 % auf 93 % ansteigt."
      }), _jsx(_components.p, {
        children: "Trotz dieser Verbesserungen bleibt der Analphabetismus in vielen Ländern weiterhin weit verbreitet, insbesondere bei Frauen. In Lateinamerika und der Karibik zeigen sich die langsamen Fortschritte auf relativ hohem Niveau in Bereichen mit stark benachteiligten, \"schwer erreichbaren\" Gruppen. In Ecuador hat sich die Alphabetisierungsrate erwachsener Frauen in ländlichen Gebieten in den letzten 10 Jahren kaum verändert und liegt bei etwa 83 %."
      }), _jsx(_components.p, {
        children: "In den Ländern Subsahara Afrikas können über 40 % der erwachsenen Frauen (25–64 Jahre) nicht lesen. In vielen Ländern sind die Fortschritte auf einem sehr niedrigen Niveau zum Stillstand gekommen, wie zum Beispiel in Mali, wo weniger als 17 % der Bevölkerung lesen können, oder sie sind nur langsam vorangekommen, wie in der Vereinigten Republik Tansania, die sich innerhalb von zehn Jahren von 72 % auf 77 % verbessert hat."
      }), _jsx(_components.p, {
        children: "Der weltweite Anstieg der Lese- und Schreibfähigkeiten bei Erwachsenen lässt sich vor allem darauf zurückführen, dass mehr Erwachsene in ihrer Jugend zur Schule gegangen sind. Es liegt nicht daran, dass Erwachsene, die nicht zur Schule gegangen sind, eine zweite Chance zum Lernen erhalten haben. Um diese Behauptung zu überprüfen, zeigt die folgende Grafik Daten, die die Lese- und Schreibfähigkeiten einer bestimmten Kohorte (Gruppe) im Laufe der Zeit verfolgen, wobei der Fokus auf dem Alter liegt."
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "LITCOHORT"
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["In den meisten Ländern stagnierte die Alphabetisierung", _jsx(HighlightByIndex, {
              index: "0",
              children: "von Erwachsenen"
            }), " oder ging sogar im Laufe der Zeit zurück, da die Fähigkeiten nicht ausreichend genutzt wurden."]
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["In ", _jsx(_components.strong, {
              children: "Burkina Faso"
            }), " zeigt die blaue Linie, dass die Alphabetisierungsrate von ", _jsx(HighlightByIndex, {
              index: "0",
              children: "Frauen im Alter von 20-34 Jahren im Jahr 2003"
            }), ", ", _jsx(HighlightByIndex, {
              index: "0",
              children: "27-41 Jahren im Jahr 2010"
            }), " und ", _jsx(HighlightByIndex, {
              index: "0",
              children: "38-62 Jahren im Jahr 2021"
            }), " relativ stabil geblieben. Da jedoch immer mehr junge Frauen lesen und schreiben können, zeigt die rote Linie, dass ", _jsx(HighlightByIndex, {
              index: "1",
              children: "die Alphabetisierungsrate der 20- bis 34-jährigen Frauen"
            }), " im Laufe der Zeit zugenommen hat."]
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.6.1",
      children: [_jsx(_components.p, {
        children: "Die Lese- und Schreibfähigkeiten, die in diesen Bewertungen gemessen werden, sind grundlegender Natur. Sie zeigen, ob Menschen in der Lage sind, einen einfachen Satz zu lesen und zu verstehen. Funktionale Alphabetisierung bezieht sich auf die Fähigkeit, komplexere schriftliche Inhalte wie Anweisungen, formelle Briefe oder Verträge zu lesen und zu verstehen, was eine höhere Kompetenz erfordert als die grundlegende Lese- und Schreibfähigkeit."
      }), _jsx(_components.p, {
        children: "Es gibt nur wenige internationale Erhebungen, die regelmäßig Daten zur funktionalen Alphabetisierung sammeln, da diese Art der Messung komplexer ist und höhere Anforderungen an die Erhebungsmethoden stellt."
      }), _jsx(_components.p, {
        children: "Die verfügbaren Daten zeigen, dass mehr als jeder zehnte städtische Erwachsene in Kolumbien und Vietnam sowie jeder vierte in Bolivien nicht über funktionale Lese- und Schreibfähigkeiten verfügt, was bedeutet, dass sie unter die Stufe 1 fallen."
      }), _jsxs(_components.p, {
        children: ["In ", _jsx(_components.strong, {
          children: "Ghana"
        }), " verfügen selbst unter den städtischen Erwachsenen nur 39 % über funktionale Lese- und Schreibkenntnisse."]
      }), _jsx(Figure, {
        id: "LITPROF"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "schlussfolgerung",
      children: "Schlussfolgerung"
    }), "\n", _jsx(_components.p, {
      children: "Obwohl im Rahmen des SDG 4 der Schwerpunkt auf die Überwachung des Lernens verlagert wurde, fehlen immer noch die Berichte vieler Länder über die Indikatoren für Lernergebnisse in den Bereichen Lesen und Mathematik. Selbst Länder, die damit beginnen wollen, das Lernen zu bewerten und darüber zu berichten, stoßen oft auf Hindernisse, die sie daran hindern, wirksame und kosteneffiziente Lösungen umzusetzen. Die vorliegenden Erkenntnisse deuten jedoch darauf hin, dass die meisten Schüler in den ärmsten Ländern der Welt nicht einmal die grundlegendsten Fähigkeiten beherrschen."
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://openknowledge.worldbank.org/handle/10986/32553",
            children: "Ending learning poverty – what will it take? – World Bank"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "http://uis.unesco.org/sites/default/files/documents/ip61-combining-data-out-of-school-children-completion-learning-offer-more-comprehensive-view-sdg4.pdf",
            children: "Combining Data on Out-of-School Children, Completion and Learning to Offer a More Comprehensive View on SDG 4 – UIS"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://unesdoc.unesco.org/ark:/48223/pf0000225660",
            children: "EFA GMR 2013/4: Teaching and learning: Achieving quality for all"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://gemreportunesco.wordpress.com/2019/05/20/the-learning-assessment-market-pointers-for-countries-part-2/",
            children: "The learning assessment market - pointers for countries"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
